import React, { Component } from 'react';
import { Row, Col } from 'antd';
import './styles.scss';
import friday from './img/logo_friday.png';
import comprando_online from './img/comprando_online.png';
import comprando_online_mobile from './img/comprando_online_mobile.png';
import icon_star from './img/icon_star.png';
import descuento from './img/descuento.png';
import reloj from './img/reloj_logo.png';
import dinero_imagen from './img/dinero_imagen.png';
import foto from './img/foto_img.png';
import foto_mobile from './img/foto_img_mobile.png';
import click from './img/click.svg';

import icono_parlante from './img/icono_parlante.webp';
import icono_parlante_mobile from './img/icono_parlante_mobile.webp';
import logo_20_anhos from './img/logo_20_anos.webp';
import logo_20_anhos_mobile from './img/logo_20_anhos_mobile.webp';
import precio_especial from './img/precio_especial.webp';
import precio_especial_mobile from './img/precio_especial_mobile.webp';
import icono_bar_menu from './img/icono_bar_menu.webp';
import icono_bar_menu_mobile from './img/icono_bar_menu-mobile.webp';
import icono2_bar_menu from './img/icono2_bar_menu.webp';
import icono2_bar_menu_mobile from './img/icono2_bar_menu-mobile.webp';

class Barra extends Component {
  render() {
    if (window.location.pathname === '/cloud') {
      return (
        <>
        {
          <div className="campania__negocios__online">
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="mensaje">
                  <span className="header--mensaje__texto">
                    Disfruta de <span className="header--texto__reasaltado">Contasiscorp Cloud</span> Contabilidad 100% nube
                    <img className="icon_star" src={icon_star} alt='icono star'/>
                    totalmente gratis
                    <img className="icon_star" src={icon_star} alt='icono star'/>
                  </span>
                  <a
                    className="button button--primary button--md button__descuento"
                    target="_blank"
                    href={'https://www.contasiscorpcertificacion.com/curso-estructurado/profesional'}
                    rel="noreferrer"
                  >
                    Empieza ahora
                  </a>
                </div>
              </Col>
            </Row>
          </div>
          }
        </>
      );
    } else if (window.location.pathname === '/' || window.location.pathname === '/contador-digital' || window.location.pathname === '/contador-digital/soluciones-contador'){
      return (
        <>{
        <a href='contador-digital'>
          <div className="contenedor--full">
            <div className="contenedor--full_blackfriday">
              <span className='vista_web'>
                <div className="header__backfriday">                
                  <img className='icono_bar_menu1' src={icono_bar_menu} />
                  <div className='texto'>
                    <div className='parte01'>¡Más licencias y más ahorro!</div>
                    <div className='parte02'>
                      <span className='bold'>Adquiere 2 o más licencias de nuestro Contable SQL y <span className='mostaza'>paga menos.</span></span> Además, <span className='mostaza'>obtén 10% dscto</span> adicional comprando aquí
                    </div>
                  </div>
                  <img className='icono_bar_menu2' src={icono2_bar_menu} />
                </div>
              </span>
              <span className='vista_mobile'>
                <div className="header__backfriday">                
                  <div className='texto'>
                    <div className='parte01'>¡Más licencias y más ahorro! </div>
                    <div className='parte02'>
                      Adquiere 2 o más licencias de nuestro Contable SQL y <span className='mostaza'>paga menos. </span><br/>
                      Además, <span className='mostaza'>obtén 10% dscto</span> adicional comprando aquí
                    </div>
                  </div>
                  <div className='imagenes'>
                    <img className='icono_bar_menu icono_bar_menu2' src={icono2_bar_menu_mobile} />
                    <img className='icono_bar_menu icono_bar_menu1' src={icono_bar_menu_mobile} />                    
                  </div>
                </div>
              </span>
            </div>
          </div>
        </a>
        }
        </>
      );
    }else {
      return (
        <div className="campania__negocios__online">
          
        </div>
      );
    }
  }
}

export default Barra;
